import { MaxLength, IsOptional, IsISO8601, IsString, MinLength } from 'class-validator';

export class SearchDTO {
    
    @IsOptional()
    @MaxLength(50)
    searchFor: string;
    
    @IsOptional()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    exclude: Array<string>;

    @IsOptional()
    @IsISO8601()
    from?: string;

    @IsOptional()
    @IsISO8601()
    to?: string;

}
